import appOptionsRo from "@commonLang/ro/app_options";
import appOptionCategoriesRo from "@commonLang/ro/app_option_categories";
import documentationsRo from "@commonLang/ro/documentations";
import cronTaskCategoriesRo from "@commonLang/ro/cron_task_categories";
import payuNotificationsRo from "@commonLang/ro/payu_notifications";
import payuPaymentsRo from "@commonLang/ro/payu_payments";
import currencyConversionsRo from "@commonLang/ro/currency_conversions";
import appRo from "@commonLang/ro/app.js"

export default {
    en: {},
    ro: {
        'app': appRo,
        'app_options': appOptionsRo,
        'app_option_categories': appOptionCategoriesRo,
        'documentations': documentationsRo,
        'cron_task_categories': cronTaskCategoriesRo,
        'currency_conversions': currencyConversionsRo,
        "payu_notifications": payuNotificationsRo,
        'payu_payments': payuPaymentsRo,
    }
}
